export default defineNuxtRouteMiddleware((to) => {
    const { isFeatureEnabled } = useFeatureFlags();
    if (!isFeatureEnabled('login')) {
        return;
    }

    const { isKeycloakInitialized, isAuthenticated, login } = useAuth();

    if (!isKeycloakInitialized.value) {
        return abortNavigation();
    }
    else if (!isAuthenticated.value) {
        return login(to);
    }
});
